import React from 'react';
import AdvisoryBoardCarousel from '../../component/common/advisory';
import MediaCarousel from '../../component/common/media';
import CTA from '../../component/common/CTA';
import Hero from '../../component/home/hero';
import WhatWeDo from '../../component/home/whatWeDo';
import HowWeDoIt from '../../component/home/howWeDoIt';
import { FaArrowRight } from "react-icons/fa6";
import { Helmet } from 'react-helmet-async';
import Banner from '../../component/common/Banner';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import Reviews from '../../component/common/reviews';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/pagination';
import SuccessStatsSection from '../../component/home/stats';
import TurningIdeasSection from '../../component/home/ideaSection';
import ExecutionSection from '../../component/home/executionSection';
import HowWeDoItSection from '../../component/home/howWeDo';

const boardMembers = [
    {
        img: "/img/advisory/ashish.png",
        name: "Ashish Mittal",
        position: "Founder & Chief Mentor",
        link: "https://www.linkedin.com/in/mittalashish",
    },
    {
        img: "/img/advisory/vivek.jpg",
        name: "Vivek Srivastava",
        position: "HealthTech Advisor",
        link: "https://www.linkedin.com/in/vivek-srivastava-/",
    },
    {
        img: "/img/advisory/prashant.jpg",
        name: "Prashant Lohia",
        position: "RetailTech Advisor",
        link: "https://www.linkedin.com/in/ginesys/",
    },
    {
        img: "/img/advisory/gagan.jpg",
        name: "Gagan Jain",
        position: "SaaSTech Advisor",
        link: "https://www.linkedin.com/in/gaganmsjain/",
    },
    {
        img: "/img/advisory/vikas.jpg",
        name: "Vikas Chowdhary",
        position: "Fintech Advisor",
        link: "https://www.linkedin.com/in/vikaschaudhary-6equj5/",
    },
    {
        img: "https://picsum.photos/600/600",
        name: "Dr. V Gopal",
        position: "Edtech Advisor",
        link: "https://www.linkedin.com/in/dr-v-gopal-5a6082a",
    },
];

const mediaData = [
    {
        title: "Student housing Startup Your-space raises Angel Funding",
        date: "January 2025",
        link: "https://www.vccircle.com/exclusive-student-housing-startup-your-space-raises-angel-funding",
    },
    {
        title: "TurningIdeas Venture to help startups with early investments",
        date: "February 2025",
        link: "https://economictimes.indiatimes.com/small-biz/money/turningideas-venture-to-help-startups-with-early-investments/articleshow/52863561.cms",
    },
    {
        title: "42 per cent of Indian Startups Plan to Go Global",
        date: "January 2025",
        link: "https://www.business-standard.com/content/press-releases-ani/42-per-cent-of-indian-startups-plan-to-go-global-in-2022-turningideas-survey-121121601096_1.html",
    },
    {
        title: "Student housing Startup Your-space raises Angel Funding",
        date: "January 2025",
        link: "https://www.vccircle.com/exclusive-student-housing-startup-your-space-raises-angel-funding",
    },
];

const BANNER_CONTENT = [
    {heading : 'We don’t Just Advise, ' , subHeading : 'We Co-Build Startups' , description : `From idea to MVP, GTM to Scale – we’re your execution partner in India and Asia.  ` , url : 'https://forms.gle/Brpzz6dAtLtcTYc9A' , linkText : 'Lets Talk'},
    { subHeading : 'Tired of MVP delays, GTM confusion, or Investor Rejections?' , description : 'We are a venture studio that partners with startup teams to build, validate, and scale innovative ideas in India and Asia.' , url : '/indian' , target : '_self' , linkText: 'Apply Now'},
    { subHeading : 'You’ve Raised Capital. Now Let’s Build Momentum' , description : 'We help global startups land and scale in India – with local teams, enterprise access, and go-to-market support' , url : '/global' , target : '_self' , linkText: 'Apply Now'},
    { subHeading : 'Innovation doesn’t happen in Silos' , description : 'We help enterprises discover, validate, and integrate startup-led solutions that solve real business challenges.' , url : '/enterprise' , target : '_self' , linkText: 'Apply Now'},
    { heading : 'TurningIdeas LaunchHub – Noida' , subHeading : 'A 12-Week Founder Residency With Zero Upfront Fee' , description : 'Build with operators. Execute with experts. Grow with confidence.' , url : 'https://forms.gle/2F4A8ZQeJ4XTmVMa8' , linkText: 'Apply Now' , type : 'launchub'}
]

const offerings = [
    {
        tag: 'For Indian Startups',
        title: 'Build to scale',
        image: 'img/indian-startups-scale.png', // Placeholder for the meeting image
        features: [
            "Product-Market Fit & GTM Execution: Validating and scaling your product.",
            "Sales Acceleration & Enterprise Partnerships: Connecting with customers & enterprises.",
            "Operational Scale-Up: Optimizing processes for rapid expansion.",
        ],
        buttonText: 'Accelerate Growth',
        linkUrl : '/indian',
        buttonNote : ['No Upfront cost' , 'Equity and revenue share models']
    },
    {
        tag: 'For Global Startups',
        title: 'Expand in India with confidence',
        image: 'img/global-startup-expand.png', // Placeholder for the global map image
        features: [
            "Market Research & Localization: Understanding cultural & business dynamics.",
            "Regulatory & Compliance Support: Navigating Indian legal frameworks.",
            "Sales & Distribution Partnerships: Connecting with the right industry players.",
            "Investor & Funding Access: Raising capital through our ecosystem.",
        ],
        buttonText: 'Expand in India',
        linkUrl : '/global',
        buttonNote: ['Retainer fee with success fee model']
    }
];

const HomePage = () => {
    return (
        <div className="">

            <Helmet>
                <title>Startup Studio | Co-Build, Scale, and Fund with TurningIdeas</title>
                <meta name="description" content="TurningIdeas is a hands-on startup studio helping founders build MVPs, launch in India, and accelerate growth through GTM, sales, and fundraising support." />
                <meta name="keywords" content="startup studio India, co-build startup, MVP development India, startup GTM services" />
            </Helmet>



            <Banner content={BANNER_CONTENT} img='img/Banner/HomePage.png' />
            {/* Hero Section */}

            <SuccessStatsSection />

            <TurningIdeasSection />

            <ExecutionSection offerings={offerings} />

            <HowWeDoItSection />

            <Reviews />

            {/* LOGO CAROUSELF */}
            <div className="sm:mb-32 mt-40 container max-w-7xl mx-auto px-6 md:px-12">
                <Swiper
                    slidesPerView={1}
                    spaceBetween={30}
                    breakpoints={{
                        640: { slidesPerView: 1, spaceBetween: 40 },
                        768: { slidesPerView: 2, spaceBetween: 50 },
                        1024: { slidesPerView: 3, spaceBetween: 60 },
                    }}
                    loop={true}
                    modules={[Navigation, Pagination, Autoplay]}
                    // pagination={{ clickable: true }}
                    autoplay={{
                        delay: 3000,
                    }}
                >
                    {[
                        { img: "/img/modc.png", name: "Your Space" },
                        { img: "/img/logos/cloudverse.png", name: "EaseMyGST" },
                        { img: "/img/score-me.png", name: "TurningCloud" },
                        { img: "/img/cast.png", name: "Your Space" },
                        { img: "/img/logos/ginesys.png", name: "EaseMyGST" },
                    ].map((item, index) => (
                        <SwiperSlide key={index}>
                            <div className="flex items-center justify-center">
                                <img src={item.img} alt={item.name} className="max-h-24 max-w-full object-contain" />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            {/* Logos Carousel */}

            <section className="md:py-12 bg-black">
                <div className="container mx-auto px-6 md:px-12">
                    <MediaCarousel mediaItems={mediaData} />
                </div>
            </section>

            <CTA
                heading="Want a Partner to Co-Build"
                paragraph="Whether you're a Startup, Investor or Enterprise, We help you Scale, Innovate and Succeed."
                buttonText="Contact Us Today!"
            />

        </div>
    );
};

export default HomePage;
